module.exports = __webpack_public_path__ + "img/logopwa.15536f81.png";